import React, { useState, useEffect, useContext, useMemo } from 'react';
import * as R from 'ramda';
//import styles from './css/InvoiceList.scss';
import { green, red } from '@mui/material/colors';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeaderCD from '../component/CardHeaderCD';
import ButtonGroup from '@mui/material/ButtonGroup';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import { postJSONPS } from '@cd/utils';
import { either, indexMap } from '@cd/utils';
import { CenterProgress } from '../component/CenterProgress';
import cn from 'classnames';
import EventNote from '@mui/icons-material/EventNote';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PaidIcon from '@mui/icons-material/Paid';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { useHistory } from 'react-router-dom';
import PDFView from './PDFView';
import { store } from './store';
import { countPaidInvoices, groupPaidByTransactionID } from './helpers';
import { Box, Divider, Paper, Tab, Tabs } from '@mui/material';
import { css, useTheme } from '@emotion/react';
import Details from './Details';
import { column, row } from './commonCSS';
import OrganizationInfoLabel from './OrganizationInfoLabel';
import { motion } from 'framer-motion';

const styles = {};

const getTotal = R.pathOr('0.00', [0, 'total']);

const getSubtotal = R.compose(
	v => v.toFixed(2),
	list => {
		return list?.reduce((acc, { amount }) => acc + +amount, 0, list) ?? 0;
	},
	R.tap(item => console.log(':', item))
);

const LabelValue = ({
	label,
	value,
	labelColor = '',
	valueColor = 'primary'
}) => (
	<Box sx={row}>
		<Typography sx={{ mr: 1 }} variant="caption" color={labelColor}>
			{label}:
		</Typography>
		<Typography variant="caption" color={valueColor}>
			{value}
		</Typography>
	</Box>
);

const cornerItemStyle = css({
	//border: '1px solid var(--color)',
	backgroundColor: 'var(--color)',
	display: 'inline-block',
	position: 'absolute',
	top: '14px',
	left: '-22px',
	textAlign: 'center',
	width: '94px',
	transform: 'rotate(-45deg)',
	boxShadow: 'rgba(0,0,0,0.1) 4px 4px 4px',
	zIndex: 10
});

const CornerItem = ({ text, color }) => {
	return (
		<Typography
			style={{ '--color': color }}
			css={cornerItemStyle}
			variant="caption">
			<span>{text}</span>
		</Typography>
	);
};

const getInvoice2Line = (isPaid, invoice) => (
	<Box sx={column}>
		<LabelValue
			label="Status"
			value={isPaid ? 'PAID' : 'NOT PAID'}
			valueColor={isPaid ? 'secondary' : 'primary'}
		/>
		<LabelValue label="Created" value={invoice.create_date} />
		<LabelValue
			label={isPaid ? 'Paid on' : 'Due date'}
			value={isPaid ? invoice.pay_date : invoice.payment_due_date}
		/>
	</Box>
);

function onPayAll(history) {
	history.push('/account/pay/0/payment');
}
const titleImageVariants = {
	open: {
		opacity: 1,
		width: 'clamp(120px, 50%, 240px)',
		transition: {
			type: 'spring',
			bounce: 0.3,
			duration: 0.5
		}
	},
	close: {
		opacity: 0,
		width: '120px',
		transition: {
			type: 'spring',
			bounce: 0.3,
			duration: 0.5
		}
	}
};

function InvoiceImage({ isOpen }) {
	return (
		<motion.img
			initial="close"
			variants={titleImageVariants}
			animate={'open'}
			css={css({
				width: 'clamp(40px, 100%, 320px)',
				alignSelf: 'self-start'
			})}
			src="/api/image/get/invoices"
			alt="logo"
			style={{
				borderRadius: '4px'
			}}
		/>
	);
}

const PayListIsland = ({
	data,
	isPaid,
	classes,
	totalCmp,
	headerTitle,
	paymentDisabled
}) => {
	const { palette } = useTheme();
	const isDark = palette.mode === 'dark';
	const bgColor = isDark ? palette.primary.main : palette.secondary.main;

	const groups = useMemo(
		() => R.compose(R.toPairs, R.groupBy)(R.prop('id'), data),
		[data]
	);
	const history = useHistory();
	const { dispatch } = useContext(store);
	function onPay(id) {
		history.push(`/account/pay/${id}/payment`);
	}

	function onViewPDF(invoiceID) {
		console.log('invoiceID', invoiceID);

		dispatch({
			type: 'open dialog',
			dlgCmp: (
				<PDFView url={`/api/invoice/view/INVOICE_${invoiceID}.pdf`} />
			)
		});
	}

	return data.length ? (
		<Card>
			<CardHeaderCD title={headerTitle} />
			<List>
				{indexMap(
					([invoiceID, charges], invoiceIndex) => (
						<Paper
							sx={{
								mb: 2,
								p: 2,
								overflow: 'hidden',
								position: 'relative'
							}}
							elevation={2}
							key={invoiceIndex}>
							<CornerItem
								text={isPaid ? 'PAID' : 'NOT PAID'}
								color={isPaid ? green[500] : red[500]}
							/>
							<ListItem>
								<Box
									sx={{
										flex: 1,
										display: 'flex',
										flexDirection: 'column',
										gap: 2
									}}>
									<Box
										sx={{
											display: 'flex',
											justifyContent: 'space-between',
											flexWrap: 'wrap',
											gap: 2
										}}>
										<Box sx={column}>
											<Typography
												sx={{
													display: 'flex',
													flexWrap: 'wrap'
												}}>
												<Typography sx={{ mr: 1 }}>
													INVOICE ID:
												</Typography>
												<Typography
													color="primary"
													component="span"
													sx={{
														whiteSpace:
															'break-spaces'
													}}>
													{invoiceID}
												</Typography>
											</Typography>
											<Divider sx={{ mb: 1 }} />
											{getInvoice2Line(
												isPaid,
												charges[0]
											)}
										</Box>
										<ButtonGroup
											color="primary"
											aria-label="contained primary button group"
											size="small"
											variant="contained"
											sx={{ alignSelf: 'flex-end' }}>
											<Button
												variant="outlined"
												onClick={() =>
													onViewPDF(invoiceID)
												}>
												{isPaid ? 'INVOICE PDF' : 'PDF'}
											</Button>
											{!isPaid && (
												<Button
													disabled={paymentDisabled}
													onClick={() =>
														onPay(invoiceID)
													}>
													PAY
												</Button>
											)}
										</ButtonGroup>
									</Box>

									<List disablePadding>
										<Details
											title={`Details: ${
												charges.length
											} Item${
												charges.length > 1 ? 's' : ''
											}`}
											main={palette.primary.main}
											bgColor={bgColor}
											userStyles={css({
												border: 'none'
											})}>
											{charges.map(
												(invoice, chargeIndex) => (
													<ListItem key={chargeIndex}>
														<ListItemAvatar
															sx={{
																minWidth: '32px'
															}}>
															<LabelImportantIcon />
														</ListItemAvatar>
														<Box
															sx={{
																flex: 1,
																mr: 1,
																fontSize:
																	'clamp(0.1rem,0.5rem + 1vw,0.8rem)'
															}}>
															{
																invoice.product_name
															}
														</Box>
														<Box
															className={
																styles.payIsland
															}>
															<Typography
																variant="body"
																gutterBottom>
																<span
																	className={
																		styles.amount
																	}>
																	$
																	{
																		invoice.amount
																	}
																</span>
															</Typography>
														</Box>
													</ListItem>
												)
											)}
										</Details>
										{!isPaid && (
											<>
												<Divider />
												<ListItem key={'total'}>
													<ListItemText primary="Invoice Total" />
													{
														<Typography variant="subtitle1">
															<span
																className={cn({
																	[styles.amount]:
																		!isPaid
																})}>
																$
																{getSubtotal(
																	charges
																)}
															</span>
														</Typography>
													}
												</ListItem>
											</>
										)}
									</List>
								</Box>
							</ListItem>
						</Paper>
					),
					groups
				)}
				{totalCmp}
			</List>
		</Card>
	) : null;
};

const PaymentsDiabled = () => (
	<Card>
		<CardHeaderCD title="PAYMENTS TEMPORARILY DISABLED" />
		<CardContent className={styles.invoiceInfo}>
			The payment system has been DISABELD for testing purposes and will
			go live on February 1st, 2021
		</CardContent>
	</Card>
);

const firstOfMonthStyle = css({
	display: 'inline-block',
	padding: '4px 2px',
	color: 'white',
	backgroundColor: 'rgb(19, 93, 230)',
	borderRadius: '2px'
});

const InvoiceList = ({ postError = () => {} }) => {
	const [data, setData] = useState(null);
	const { dispatch } = useContext(store);
	const [tabValue, setTabValue] = React.useState('notpaid');
	const isPaid = tabValue === 'paid';
	const history = useHistory();
	const handleTabChange = (e, tabValue) => {
		setTabValue(tabValue);
	};

	const [paymentDisabled, setPaymentDisabled] = useState(false);
	useEffect(() => {
		postJSONPS('GET', '/payment/system/status').then(
			either(postError, ({ PAYMENT_DISABLED }) => {
				setPaymentDisabled(PAYMENT_DISABLED);
				postJSONPS('GET', '/invoice/list').then(
					either(postError, data => {
						const outstanding = data.filter(
							({ is_paid }) => !is_paid
						);
						setData({
							paid: groupPaidByTransactionID(data),
							paidCount: countPaidInvoices(data),
							outstanding,
							outstandingCount: R.compose(
								R.length,
								R.uniqBy(R.prop('id'))
							)(outstanding)
						});
					})
				);
			})
		);
	}, []);

	const totalCmp = (
		<>
			<Divider sx={{ mt: 1 }} />
			<ListItem key={'total'}>
				<ListItemText primary="Total" />
				{
					<Typography variant="subtitle1" css={column}>
						<span>${getTotal(data?.outstanding)}</span>
						{data?.outstanding?.length > 1 ? (
							<Button
								disabled={paymentDisabled}
								size="small"
								variant="contained"
								color="primary"
								onClick={e => onPayAll(history)}>
								PAY ALL
							</Button>
						) : null}
					</Typography>
				}
			</ListItem>
		</>
	);

	return data === null ? (
		<CenterProgress />
	) : (
		<div>
			{paymentDisabled && <PaymentsDiabled />}
			<Card>
				<CardHeaderCD title="INVOICES" />
				<CardContent css={column}>
					<Box
						sx={[row, {
							mb: 1,
							gap: '8px',
							flexWrap: 'wrap',
							justifyContent: 'space-between'
						}]}>
						<InvoiceImage />
						<OrganizationInfoLabel />
					</Box>
					<Divider sx={{ mt: 1, mb: 1 }} />
					<div>
						<EventNote />
					</div>
					<Typography variant="body2">
						You currently receive 1 invoice a month.
						<br />
						The invoice will be created on the following day:
						<br />
						<span css={firstOfMonthStyle}>1st of the month</span>
					</Typography>

					{totalCmp}
				</CardContent>
			</Card>
			<br />

			<Tabs
				sx={{ mb: 2 }}
				textColor="primary"
				value={tabValue}
				onChange={handleTabChange}
				indicatorColor="primary"
				aria-label="secondary tabs example">
				<Tab
					icon={<CreditCardIcon />}
					value="notpaid"
					label={'OUTSTANDING: ' + (data?.outstandingCount ?? '')}
					variant="outlined"
				/>
				<Tab
					value="paid"
					label={'PAID: ' + (data?.paidCount ?? '')}
					icon={<PaidIcon />}
				/>
			</Tabs>

			{!isPaid && (
				<PayListIsland
					paymentDisabled={paymentDisabled}
					headerTitle="List of invoices"
					totalCmp={totalCmp}
					isPaid={false}
					data={data.outstanding}
				/>
			)}

			{isPaid &&
				data.paid &&
				indexMap(
					(v, index) => (
						<div key={index}>
							<PayListIsland
								headerTitle={
									<Box
										sx={[row, {
											justifyContent: 'space-between'
										}]}>
										<Box sx={row}>
											<ReceiptIcon />
											<span>RECEIPT</span>
										</Box>
										<Button
											color="primary"
											variant="outlined"
											onClick={() =>
												dispatch({
													type: 'open dialog',
													dlgCmp: (
														<PDFView
															url={`/api/receipt/view/RECEIPT_${v[0].transaction_id}.pdf`}
														/>
													)
												})
											}>
											VIEW RECEIPT
										</Button>
									</Box>
								}
								isPaid={true}
								data={v}
							/>
							<span />
						</div>
					),
					data.paid
				)}
		</div>
	);
};

export default InvoiceList;
